import React, { useEffect, useState } from "react";
import { Icon } from "../../icons/icons";
import { useField } from "formik";
import { useTranslation } from "../../context/TranslationContext";

const PaymentMethod = () => {
  const {
    paymentMethod1Title,
    paymentMethod2Title,
    paymentMethod1Description,
    paymentMethod2Description,
  } = useTranslation();
  const [field, meta, helpers] = useField("paymentMethod");

  const [payment, setPayment] = useState(meta.initialValue);

  useEffect(() => {
    helpers.setValue(payment);
  }, [payment]);

  return (
    <div className="flex sm:h-44 items-center flex-col sm:flex-row gap-y-4 py-5 sm:py-0">
      <div className="px-6 sm:w-1/2">
        <label className="relative flex pl-11 items-center cursor-pointer">
          <input
            type="radio"
            className="w-0 h-0"
            name="payment"
            value="1"
            onChange={(e) => setPayment(1)}
          ></input>
          <span
            className={
              "w-6 h-6 rounded-full border-[3px] absolute left-0 top-3 flex items-center justify-center before:content[''] before:w-2 before:h-2 before:bg-primary before:inline-block before:rounded-full before:transition before:transform   " +
              (payment == "1" ? "before:scale-1" : "before:scale-0")
            }
          ></span>
          <div className="self-start mt-0.5">
            <Icon name={"PaymentOption1"}></Icon>
          </div>
          <div className="flex flex-col ml-5">
            <span className="mb-2 text-15">{paymentMethod1Title}</span>
            <span className="text-13 text-brand-gray-9 -mt-1">
              {paymentMethod1Description}
            </span>
          </div>
        </label>
      </div>
      <div className="px-6 sm:w-1/2">
        <label className="relative flex pl-11 items-center cursor-pointer">
          <input
            type="radio"
            className="w-0 h-0"
            name="payment"
            value="2"
            onChange={(e) => setPayment(2)}
          ></input>
          <span
            className={
              "w-6 h-6 rounded-full border-[3px] absolute left-0 top-3 flex items-center justify-center before:content[''] before:w-2 before:h-2 before:bg-primary before:inline-block before:rounded-full before:transition before:transform   " +
              (payment == "2" ? "before:scale-1" : "before:scale-0")
            }
          ></span>
          <div className="self-start mt-0.5">
            <Icon name={"PaymentOption2"}></Icon>
          </div>
          <div className="flex flex-col ml-5">
            <span className="mb-2 text-15">{paymentMethod2Title}</span>
            <span className="text-13 text-brand-gray-9 -mt-1">
              {paymentMethod2Description}
            </span>
          </div>
        </label>
      </div>
    </div>
  );
};

export default PaymentMethod;
